<template lang="pug">
  v-form(ref="artistic-concept" lazy-validation): v-row.px-5
    v-col(cols="12")
      label.primary--text 32. Mein künstlerisches Konzept fällt am ehesten in die Kategorie (wenn nicht zuordbar sonstige auswählen)

      p.text-preview(v-if="readonly") {{ formData.rechercheprojekte }}
      v-select(
        v-else
        v-model="formData.rechercheprojekte"
        outlined
        dense
        placeholder="Bitte Auswählen!"
        persistent-placeholder
        :items="concepts"
        :rules="[ rules.required ]"
        @input="(v) => saveFieldValue('rechercheprojekte', v)"
      )

    v-col(cols="12")
      label.primary--text 33. Künstlerisches Konzept/Projektskizze
      .hint-label.mb-1
        p.mb-0
          | Beschreiben Sie Ihre Idee/Ihr Konzept, für die künstlerische Tätigkeit, die durch das Stipendium ermöglicht werden soll (maximal 2.000 Zeichen ohne. Leerzeichen Text ohne Textauszeichnung wie Überschriften, Gliederungen etc.). Entscheidend sind die Ziele und Wege, wie die Ziele erreicht werden sollen. <br>Die Beschreibung sollte u. a. folgende Angaben enthalten:<br>
          | - Titel für die künstlerische Tätigkeit bzw. das Projekt oder die Maßnahme,<br>
          | - Ziel, Ergebnis: Was möchten Sie tun? Wie möchten Sie das Ziel erreichen?<br>
          | - Ggf. mit wem möchten Sie zusammenarbeiten?<br>
          | - Wen möchten Sie mit diesem Projekt erreichen?<br>
          | - Welchen zeitlichen Rahmen haben Sie für das Projekt vorgesehen?<br>
          | - Wie bzw. in welcher Form ist eine Dokumentation des Projektverlaufs und des Ergebnisses vorgesehen?

      p.text-preview(v-if="readonly") {{ formData.kuenstlerisches_konzept }}
      v-textarea(
        v-else
        v-model="formData.kuenstlerisches_konzept"
        outlined
        dense
        :rows="5"
        :rules="[ rules.required, rules.maxLen(2000) ]"
        @input="(v) => saveFieldValue('kuenstlerisches_konzept', v)"
      )

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],
})
export default class ArtisticConcept extends Vue {
  @Prop({ type: Boolean, default: false }) readonly

  concepts = [
    'Rechercheprojekte für künstlerische Darbietungen',
    'Weiterbildung',
    'Produktion',
    'sonstige'
  ]

  get firstErrorField () {
    return this.getFirstErrorField('artistic-concept')
  }
}
</script>
